import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useDeleteOtp() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: () => del({ url: '/user/account/otp' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getCredentials });
    },
  });

  const deleteOtp = useCallback(() => mutate(), [mutate]);

  return { deleteOtp, error, isPending, isSuccess, reset };
}
